import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Input } from 'components/inputs'
import { useStyles } from './form.css'

const Form = (props) => {
  const classes = useStyles()
  const { disabled, data, updateEntity, localize } = props
  const { entity } = data
  if (!entity) { return null }
  return (
    <RsForm>
      <Row>
        <Col sm={props.isInDialog ? 12 : 6}>
          <Label>{localize('common.name')}</Label>
          <div className={classes.hint}><a href='https://cs.wikipedia.org/wiki/Seznam_m%C4%9Bn' target='_blank' rel='noopener noreferrer'>{localize('currencies.hint')}</a></div>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
    </RsForm>
  )
}

export default Form